import { registerArchetype } from './index.js';
import { livingEnemies, enemySide, getRuntimes } from '../combat.js';
registerArchetype({
    id: 'stun',
    apply: ({ state, source, params }) => {
        const duration = params.duration ?? 2;
        const target = params.target ?? 'lowest_hp';
        const enemies = livingEnemies(state, source.side);
        if (enemies.length === 0)
            return;
        const targets = target === 'all_enemies'
            ? enemies
            : [enemies.reduce((m, e) => e.runtime.hp < m.runtime.hp ? e : m)];
        const enemyKey = enemySide(source.side);
        for (const t of targets) {
            getRuntimes(state, enemyKey)[t.slot].statuses.push({
                id: `stun_${state.tick}_${t.slot}`,
                kind: 'stun', remainingTicks: duration, params: {}
            });
            state.events.push({ t: state.tick, kind: 'status_apply', side: enemyKey, slot: t.slot, status: 'stun', duration });
        }
    }
});
